<script lang="typescript">
    import { onMount, createEventDispatcher } from 'svelte'
    import ModalPanel from './components/ModalPanel.svelte';

    let dispatch = createEventDispatcher();

    export let active_theme;

    let selected_theme;
    onMount(() => selected_theme = active_theme);
   
    $: changeTheme(selected_theme);

    function changeTheme(theme: string) {
        dispatch("theme", { theme: theme })
    }

    function close() {
        dispatch("close")
    }

    let themes = [
    {
        id: "default",
        name: "Light"
    },    
    {
        id: "cherryblossom",
        name: "Cherry Blossom"
    },
    {
        id: "dark",
        name: "Dark"
    },
    {
        id: "synthwave",
        name: "Synthwave"
    }
    ]
</script>

<ModalPanel style="top: 50%; left: 50%; transform: translate(-50%, -50%)" on:wantClose={close}>
    <div class="theme-selector">
        <h2>Select Theme</h2>
        {#each themes as theme}
        <label>
            <input type=radio bind:group={selected_theme} value={theme.id}>
            {theme.name}
        </label>
        {/each}
        <div><button on:click={()=>{ close()} }>OK</button></div>
    </div>
</ModalPanel>


<style>
	.theme-selector {
		width: 250px;
		padding: 1rem;
	}
	
    button { 
        margin-top: 1.5rem; 
        width: 100%;
    }

    h2 {
        margin: 0 0 1rem 0;
        text-align: center;
        font-family: sans-serif;
    }

	label {
		display:block;
        padding: 0.5rem;  
	}


</style>
